import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalSystemService } from '../local-system.service';

@Component({
  selector: 'app-fuji-service-presale-add',
  templateUrl: './fuji-service-presale-add.component.html',
  styleUrls: ['./fuji-service-presale-add.component.css']
})
export class FujiServicePresaleAddComponent implements OnInit {
  tab:any = "general";
  addProtocol:any = { 'service_num':60000, model_outdoor:"", serial_outdoor:"", dealer_name:"", seller_name:""}
  ac_list:any = [{ 'model':'', 'serial':'' }];
  modal:any = { "open":false, 'cntx':'', obj:{} };
  ac_list_serial:any = "";
  ac_list_model:any = "";

  constructor(public http:HttpClient, public router:Router, public system:LocalSystemService) {
  }

  ngOnInit(): void {
    this.addProtocol.seller_name = this.system.returnName();
    this.GetMaxProtocol();
  }

  AddProtocol() {
    this.ac_list_model = "";
    this.ac_list_serial = "";
    for(var ai = 0; ai < this.ac_list.length; ai++) {
      if(ai > 0) {
        if(this.ac_list[ai].model != "" || this.ac_list[ai].serial != "") {
          this.ac_list_model += ";";
          this.ac_list_serial += ";";
        }
      }
      if(this.ac_list[ai].model != "" || this.ac_list[ai].serial != "") {
        this.ac_list_model += this.ac_list[ai].model;
        this.ac_list_serial += this.ac_list[ai].serial;
      }
    }
    this.openModal('adding-protocol', {});
    let post_data = { 'service_num':this.addProtocol.service_num, 'model_outdoor':this.addProtocol.model_outdoor, 'seller_name':this.addProtocol.seller_name, 'dealer_name':this.addProtocol.dealer_name,
    'serial_outdoor':this.addProtocol.serial_outdoor, 'date_of_service':this.returnDateFormatedForStorage(new Date()), 'date_of_return':"",
    'serial_list':this.ac_list_serial, 'model_list':this.ac_list_model};
 
    this.http.post("api/service.php?action=add_fuji_service_presale", post_data).subscribe((data) => {
      setTimeout(()=>{ 
        this.closeModal();
        this.router.navigate(['fuji-service-presale']);
      }, 500);
    });
  }


  GetMaxProtocol() {
    let url = "api/service.php?action=get_max_fuji_presale_service";
    this.http.get(url).subscribe((data) => {
      if(data['logged']) {
        if(data['max_fuji'] != undefined) {
          if(data['max_fuji']['service_num'] !== undefined && data['max_fuji']['service_num'] != null) {
            this.addProtocol.service_num = parseInt(data['max_fuji']['service_num']) + 1;
          }
        }
      }
    });
  }

  changeAcRow(ac, i) {
    if(i == this.ac_list.length - 1) {
      if(ac.model != '' || ac.serial != '') {
        this.ac_list.push({ 'serial':'', 'model':'' });
      }
    }
  }

  switchTab(tab) { this.tab = tab; }

  // MODEL
  openModal(cntx, obj) { this.modal = { open:true, 'cntx':cntx, 'obj':obj } }
  closeModal() { this.modal.open = false; }

  // UTILITY
  returnDateFormatedForStorage(dt) {
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2) +  " / " +  this.returnPadZero(dt.getHours(), 2) + ":" + this.returnPadZero(dt.getMinutes(), 2) + ":" + this.returnPadZero(dt.getSeconds(), 2);
  }

  returnDateFormated(dt){
    if(dt != '') {
      return this.returnPadZero(dt.getDate(), 2) + "." + this.returnPadZero(dt.getMonth()+ 1, 2) + "." + dt.getFullYear();
    } else {
      return '';
    }
  }

  returnPadZero(number, length) {

    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }

    return my_string;
  }


  returnYear(dt) { 
    if(dt !== undefined) {
      return dt.getFullYear(); 
    } else {
      return '';
    }
  }
  returnMonth(dt) {
    if(dt !== undefined) {
      return dt.getMonth() + 1; 
    } else {
      return '';
    }
  }
  returnMonthName(month) {
    if(month == 1) { return "Януари"; }
    else if(month == 2) { return "Февруари"; }
    else if(month == 3) { return "Март"; }
    else if(month == 4) { return "Април"; }
    else if(month == 5) { return "Май"; }
    else if(month == 6) { return "Юни"; }
    else if(month == 7) { return "Юли"; }
    else if(month == 8) { return "Август"; }
    else if(month == 9) { return "Септември"; }
    else if(month == 10) { return "Октомври"; }
    else if(month == 11) { return "Ноември"; }
    else if(month == 12) { return "Декември"; }
    else { return ""; }
  }
  returnDate(dt) { return dt.getDate();  }


}
